
const m = window.require("@ember/helper");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
